import type { AllRouteEndpoints } from "../routeTypes";

export const alloysAdjustCustomEventsAppGroupId = "/alloys/adjust/custom_events/:app_group_id";

export const postAlloysAdjustCustomEventsAppGroupIdCacheKeys: AllRouteEndpoints[] = [
  alloysAdjustCustomEventsAppGroupId,
];
